import type { TaskTodoListOptions, BaseTaskTodo } from 'models';
import { DateRangeType } from 'shared/constants';

import { TodoActionTypes } from './action-types';

export const requestTodoResources = (coopId: string) =>
  ({
    type: TodoActionTypes.REQUEST_TODO_RESOURCES,
    payload: coopId,
  } as const);

export const requestTodoResourcesSuccess = (
  tasks: BaseTaskTodo[],
  options: TaskTodoListOptions
) =>
  ({
    type: TodoActionTypes.REQUEST_TODO_RESOURCES_SUCCESS,
    payload: { tasks, options },
  } as const);

export const requestTodoResourcesFailed = () =>
  ({
    type: TodoActionTypes.REQUEST_TODO_RESOURCES_FAILED,
  } as const);

export const setTodoDateFilter = (dateFilter: DateRangeType) =>
  ({
    type: TodoActionTypes.SET_DATE_FILTER,
    payload: dateFilter,
  } as const);

export const setTodoStartDate = (date: Date | null) =>
  ({
    type: TodoActionTypes.SET_START_DATE,
    payload: date,
  } as const);

export const setTodoEndDate = (date: Date | null) =>
  ({
    type: TodoActionTypes.SET_END_DATE,
    payload: date,
  } as const);

export const setSearchTerm = (value: string) =>
  ({
    type: TodoActionTypes.SET_SEARCH_TERM,
    payload: value,
  } as const);

export const requestTodoList = () =>
  ({
    type: TodoActionTypes.REQUEST_TODO_LIST,
  } as const);

export const requestTodoListSuccess = (list: BaseTaskTodo[]) =>
  ({
    type: TodoActionTypes.REQUEST_TODO_LIST_SUCCESS,
    payload: list,
  } as const);

export const requestTodoListFailed = () =>
  ({
    type: TodoActionTypes.REQUEST_TODO_LIST_FAILED,
  } as const);
